import React from "react";

const DataContext = React.createContext({
  loading: true,
  prodType: 1,
  loadMore: false,
  products: [],
  baskets: [],
  setProducts: () => {},
  setBaskets: () => {},
  setLoadMore: () => {},
  setLoading: () => {},
  setProdType: () => {},
});

export default DataContext;
